// Public navigation is measured by the consent-aware first-party tracker.
// Avoid sending authenticated browsing or virtual page views to other systems.
export default function NavigationTracker() { return null; }
